/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "ja": {
        "nu": ["latn"],
        "year": {
          "0": "今年",
          "1": "来年",
          "future": {
            "other": "{0} 年後"
          },
          "past": {
            "other": "{0} 年前"
          },
          "-1": "昨年"
        },
        "year-short": {
          "0": "今年",
          "1": "来年",
          "future": {
            "other": "{0} 年後"
          },
          "past": {
            "other": "{0} 年前"
          },
          "-1": "昨年"
        },
        "year-narrow": {
          "0": "今年",
          "1": "来年",
          "future": {
            "other": "{0}年後"
          },
          "past": {
            "other": "{0}年前"
          },
          "-1": "昨年"
        },
        "quarter": {
          "0": "今四半期",
          "1": "翌四半期",
          "future": {
            "other": "{0} 四半期後"
          },
          "past": {
            "other": "{0} 四半期前"
          },
          "-1": "前四半期"
        },
        "quarter-short": {
          "0": "今四半期",
          "1": "翌四半期",
          "future": {
            "other": "{0} 四半期後"
          },
          "past": {
            "other": "{0} 四半期前"
          },
          "-1": "前四半期"
        },
        "quarter-narrow": {
          "0": "今四半期",
          "1": "翌四半期",
          "future": {
            "other": "{0}四半期後"
          },
          "past": {
            "other": "{0}四半期前"
          },
          "-1": "前四半期"
        },
        "month": {
          "0": "今月",
          "1": "来月",
          "future": {
            "other": "{0} か月後"
          },
          "past": {
            "other": "{0} か月前"
          },
          "-1": "先月"
        },
        "month-short": {
          "0": "今月",
          "1": "来月",
          "future": {
            "other": "{0} か月後"
          },
          "past": {
            "other": "{0} か月前"
          },
          "-1": "先月"
        },
        "month-narrow": {
          "0": "今月",
          "1": "来月",
          "future": {
            "other": "{0}か月後"
          },
          "past": {
            "other": "{0}か月前"
          },
          "-1": "先月"
        },
        "week": {
          "0": "今週",
          "1": "来週",
          "future": {
            "other": "{0} 週間後"
          },
          "past": {
            "other": "{0} 週間前"
          },
          "-1": "先週"
        },
        "week-short": {
          "0": "今週",
          "1": "来週",
          "future": {
            "other": "{0} 週間後"
          },
          "past": {
            "other": "{0} 週間前"
          },
          "-1": "先週"
        },
        "week-narrow": {
          "0": "今週",
          "1": "来週",
          "future": {
            "other": "{0}週間後"
          },
          "past": {
            "other": "{0}週間前"
          },
          "-1": "先週"
        },
        "day": {
          "0": "今日",
          "1": "明日",
          "2": "明後日",
          "future": {
            "other": "{0} 日後"
          },
          "past": {
            "other": "{0} 日前"
          },
          "-2": "一昨日",
          "-1": "昨日"
        },
        "day-short": {
          "0": "今日",
          "1": "明日",
          "2": "明後日",
          "future": {
            "other": "{0} 日後"
          },
          "past": {
            "other": "{0} 日前"
          },
          "-2": "一昨日",
          "-1": "昨日"
        },
        "day-narrow": {
          "0": "今日",
          "1": "明日",
          "2": "明後日",
          "future": {
            "other": "{0}日後"
          },
          "past": {
            "other": "{0}日前"
          },
          "-2": "一昨日",
          "-1": "昨日"
        },
        "hour": {
          "0": "1 時間以内",
          "future": {
            "other": "{0} 時間後"
          },
          "past": {
            "other": "{0} 時間前"
          }
        },
        "hour-short": {
          "0": "1 時間以内",
          "future": {
            "other": "{0} 時間後"
          },
          "past": {
            "other": "{0} 時間前"
          }
        },
        "hour-narrow": {
          "0": "1 時間以内",
          "future": {
            "other": "{0}時間後"
          },
          "past": {
            "other": "{0}時間前"
          }
        },
        "minute": {
          "0": "1 分以内",
          "future": {
            "other": "{0} 分後"
          },
          "past": {
            "other": "{0} 分前"
          }
        },
        "minute-short": {
          "0": "1 分以内",
          "future": {
            "other": "{0} 分後"
          },
          "past": {
            "other": "{0} 分前"
          }
        },
        "minute-narrow": {
          "0": "1 分以内",
          "future": {
            "other": "{0}分後"
          },
          "past": {
            "other": "{0}分前"
          }
        },
        "second": {
          "0": "今",
          "future": {
            "other": "{0} 秒後"
          },
          "past": {
            "other": "{0} 秒前"
          }
        },
        "second-short": {
          "0": "今",
          "future": {
            "other": "{0} 秒後"
          },
          "past": {
            "other": "{0} 秒前"
          }
        },
        "second-narrow": {
          "0": "今",
          "future": {
            "other": "{0}秒後"
          },
          "past": {
            "other": "{0}秒前"
          }
        }
      }
    },
    "availableLocales": ["ja"]
  });
}